// --- Reservation Status ---
export const ReservationStatus = {
  PENDING_AUTHORIZATION: 'PENDING_AUTHORIZATION',
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  RELEASED: 'RELEASED',
  DECLINED: 'DECLINED'
} as const

export type ReservationStatus = (typeof ReservationStatus)[keyof typeof ReservationStatus]

export const ReservationStatusLabel = {
  [ReservationStatus.PENDING_AUTHORIZATION]: 'Por Autorizar',
  [ReservationStatus.ACTIVE]: 'Activo',
  [ReservationStatus.EXPIRED]: 'Expirado',
  [ReservationStatus.RELEASED]: 'Liberado',
  [ReservationStatus.DECLINED]: 'Rechazado'
} as const satisfies Record<ReservationStatus, string>

// --- Reservation History Action ---
export const ReservationHistoryAction = {
  CREATED: 'CREATED',
  AUTHORIZATION_REQUESTED: 'AUTHORIZATION_REQUESTED',
  AUTHORIZED: 'AUTHORIZED',
  DECLINED: 'DECLINED',
  EXPIRED: 'EXPIRED',
  RELEASED: 'RELEASED'
} as const

export type ReservationHistoryAction =
  (typeof ReservationHistoryAction)[keyof typeof ReservationHistoryAction]

export const ReservationHistoryActionLabel = {
  [ReservationHistoryAction.CREATED]: 'Apartado creado',
  [ReservationHistoryAction.AUTHORIZATION_REQUESTED]: 'Autorización solicitada',
  [ReservationHistoryAction.AUTHORIZED]: 'Apartado autorizado',
  [ReservationHistoryAction.DECLINED]: 'Apartado rechazado',
  [ReservationHistoryAction.EXPIRED]: 'Apartado expirado',
  [ReservationHistoryAction.RELEASED]: 'Apartado liberado'
} as const satisfies Record<ReservationHistoryAction, string>
